import React from 'react';
import useStyles from './style';
import {
  Container,
  Grid,
  Typography
} from '@material-ui/core';


//Components

import SubHeaderAnalytics from '../common/components/SubHeaderAnalytics';
import AreaGraph from '../common/components/AreaGraph';
import HorizontalBarGraph from '../common/components/HorizontalBarGraph';
import LocationGraph from '../common/components/LocationGraph';
import PieGraph from '../common/components/PieGraph';

import WhiteBoardWithAreaGraph from '../common/components/WhiteBoardWithAreaGraph';


export default function (props) {
  var React = require('react');

  const classes = useStyles();

  return (
    <div>

      <SubHeaderAnalytics
        navigateTab={props.navigateTab}
        invokeFilterAPI={props.getGraphData}
        pathname={props.history.location.pathname}
      />

      <Container className={classes.analyticsLayout} xs={9} md={9} lg={9}>
        <Typography variant="h3" gutterBottom className={classes.pageTitle}>Platform</Typography>
        <Grid
          container
          direction="row"
          spacing={2}
        >
          <Typography variant="subtitle1" className={classes.pageTitle} style={{ margin: 0 }}>Uses Summary Report</Typography>
          <Grid
            container 
            direction="row"
            spacing={2}
          >
            <Grid item xs={6} >
              <AreaGraph
                title="Active Users"
                data={props.activeUsers}
                calltype="activeUsers"
              />
            </Grid>
            {[props.sessionInfo[0], props.sessionInfo[1], props.sessionInfo[2]].map((v) => <Grid item xs={2}>
              <WhiteBoardWithAreaGraph {...v} />
            </Grid>)}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

